import React from 'react';
import SectionBox from '../../components/SectionBox';
import '../../styles/resources/content.scss';
import '../../styles/resources/sample-court-orders.scss';
import Header from '../../components/Header';

const ORDERS = '/documents/sample-orders';

const SampleCourtOrders = () => (
  <div>
    <Header short backgroundImage={require('../../images/handshake-court.jpg')} backgroundPosition="center 40%">
      <h1>Sample Court Orders</h1>
    </Header>
    <div className="resources-content content-item sample-court-orders-page">
      <SectionBox>
        <p className="intro">
          These sample orders are adapted from various court administrators or are generic
          examples provided by area professionals. They are offered as starting points and
          should be tailored to the facts of each case.
        </p>

        <h2>Therapy</h2>
        <ul>
          <li><a href={`${ORDERS}/sample-child-counseling-order.rtf`} target="_blank" rel="noopener noreferrer">Child Therapy</a></li>
          <li><a href={`${ORDERS}/sample-individual-adult-counseling-order.rtf`} target="_blank" rel="noopener noreferrer">Individual Adult Therapy</a></li>
          <li><a href={`${ORDERS}/sample-court-order-therapy-multiple-persons.rtf`} target="_blank" rel="noopener noreferrer">Therapy with multiple persons</a> (parent-child issues, reunification, co-parenting, etc.)</li>
        </ul>

        <h2>Evaluation</h2>
        <ul>
          <li><a href={`${ORDERS}/sample-adoptive-evaluation-order.rtf`} target="_blank" rel="noopener noreferrer">Adoptive (Pre and Post combined) Evaluation Order</a></li>
          <li><a href={`${ORDERS}/sample-child-custody-evaluation-order.docx`} target="_blank" rel="noopener noreferrer">Child Custody Evaluation</a> (based on Denton County Standing Order)</li>
          <li><a href={`${ORDERS}/sample-psychological-evaluation-order.docx`} target="_blank" rel="noopener noreferrer">Psychological Evaluation</a></li>
          <li><a href={`${ORDERS}/sample-brief-focused-assessment-order.docx`} target="_blank" rel="noopener noreferrer">Brief Focused Assessment</a></li>
        </ul>

        <h2>Other</h2>
        <ul>
          <li><a href={`${ORDERS}/sample-confidentiality-order.rtf`} target="_blank" rel="noopener noreferrer">Agreed Confidentiality Order</a> (Health Information) — from Melinda Eitzen</li>
          <li><a href={`${ORDERS}/sample-mhp-gal-order.rtf`} target="_blank" rel="noopener noreferrer">Mental Health Professional appointed as Guardian Ad Litem</a></li>
          <li><a href={`${ORDERS}/tarrant-dro-non-professional-visit-supervisor-statement.pdf`} target="_blank" rel="noopener noreferrer">Non-professional visit supervisor&rsquo;s statement of responsibility</a> — from Tarrant County Domestic Relations Office</li>
          <li><a href={`${ORDERS}/sample-parenting-facilitation-order.rtf`} target="_blank" rel="noopener noreferrer">Parenting Facilitation</a></li>
          <li><a href="http://www.texascounseling.org/Forms/SV_Order.pdf" target="_blank" rel="noopener noreferrer">Supervised visitation</a> — from Forensic Counseling Services</li>
        </ul>
      </SectionBox>
    </div>
  </div>
);

export default SampleCourtOrders;
